import React from 'react'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import { Tween } from 'react-gsap';
import TittleWithAnimation from './TittleWithAnimation'



gsap.registerPlugin(ScrollTrigger);


const FounderMessage = () => {
    return (
        <section id="message-from-our-founders">
            <div className="container">
                <Tween
                    to={{ 
                        scrollTrigger: {
                            trigger: "#message-from-our-founders .small-and-big-tittle",
                            start: '150px bottom'
                        },
                        css : {
                            y: 0,
                            opacity: 1
                        }
                    }}
                >
                    <div className="small-and-big-tittle">
                        <p>Poncor Dispatch</p>
                        <h1>Message from Our Founder</h1>
                    </div>
                </Tween>


                {/* <div className="row">
                    <Founders_message_box
                        target_el="founders-message-1"
                    />
                    <Founders_message_box
                        target_el="founders-message-2"
                    />
                </div> */}

                <div className="d-flex justify-content-center align-items-center flex-column">
                    <p className='mt-5 ceo-message text-center'>A Message from Our Founder, Padmore Ayim
                        Welcome to Poncore, a groundbreaking product from Padmore Global Connections (PGC). At PGC, we are dedicated to driving innovation and creating technology solutions that transform industries. As the founder of this disruptive platform, I am excited to share with you our vision to transform the logistics, construction materials and transportation industry. Poncore is the culmination of our deep expertise in logistics, technology, and project management, designed to revolutionize the way goods are transported from origin to destination.
                        <br/> <br/>
                        Our goal with Poncore is clear: to provide businesses with a powerful, intuitive platform that simplifies logistics, improves efficiency, and eliminates unnecessary costs. Without the burden of a membership fees and unmatched flexibility, Poncore empowers you to transact business effortlessly while optimizing your supply chain.
                        Thank you for choosing Poncore. As part of the PGC family, we are committed to delivering solutions that not only meet but exceed your expectations, driving the future of moving loads forward.
                    </p>
                    <div className="user-feedback-img mt-4">
                        <img src="https://media.istockphoto.com/photos/studio-shot-of-a-handsome-and-happy-young-man-posing-against-a-grey-picture-id1355110818?b=1&k=20&m=1355110818&s=170667a&w=0&h=O58XhltYuAw0ssiUWXAFlIitq_4kj-WdJFWcTLEoUi0=" alt=""/>
                    </div>

                    <div className='text-center mt-2'>
                        <p className='ceo-name'>Padmore Ayim</p>
                        <span className='founder-designation'>Founder & CEO, Padmore Global Connections</span>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FounderMessage;


const Founders_message_box = ({target_el}) => (

    <Tween
        to={{ 
            scrollTrigger: {
                trigger: "#message-from-our-founders .founders-message",
                start: '150px bottom'
            },
            css : {
                y: 0,
                opacity: 1
            }
        }}
    >
        <div className="col-lg-6 founders-message">
            <div className="user-feedback-img">
                <img src="https://media.istockphoto.com/photos/studio-shot-of-a-handsome-and-happy-young-man-posing-against-a-grey-picture-id1355110818?b=1&k=20&m=1355110818&s=170667a&w=0&h=O58XhltYuAw0ssiUWXAFlIitq_4kj-WdJFWcTLEoUi0="
                    alt=""/>
            </div>

            <h1>John C. Arana</h1>
            <span>Co-Founder</span>
            <i className="fa-solid fa-quote-right"></i>


            <div className={`founder_message_typography ${target_el}`}>
                <TittleWithAnimation
                    word="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolore, nam. Illo adipisci
                    vitae fugit, quibusdam earum ipsa enim fuga, sunt voluptas necessitatibus officia error, iste at eos aperiam recusandae cum."
                    _trigger={`.${target_el}`}
                    _start= '50px bottom'
                />
            </div>

            <a href="#">
                <div className="founders-message-read-more founders-message-read-more_2">
                    <span>Read More</span>
                    <i className="fa-solid fa-arrow-right-long"></i>
                </div>
            </a>
        </div>
    </Tween>
)